var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPowerbi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#powerbi_svg__a)",
  d: "M18 1.001V23c0 .553-.448 1.001-1.001 1.001H10.75a1 1 0 0 1-1.001-1.001V1C9.75.448 10.198 0 10.751 0H17C17.552 0 18 .448 18 1.001"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#powerbi_svg__b)",
  d: "M13.125 7v17h-8.25V7a1 1 0 0 1 1-1h6.25a1 1 0 0 1 1 1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#powerbi_svg__c)",
  d: "M0 13v10a1 1 0 0 0 1 1h7.25V13a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "powerbi_svg__a",
  x1: 8.375,
  x2: 18.717,
  y1: 0,
  y2: 22.607,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6AD10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C87E0E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "powerbi_svg__b",
  x1: 4.874,
  x2: 13.587,
  y1: 6,
  y2: 23.425,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6D751"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6AD10"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "powerbi_svg__c",
  x1: -0.001,
  x2: 4.797,
  y1: 12,
  y2: 23.725,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9E589"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F6D751"
})))));
export { SvgPowerbi as ReactComponent };
export default __webpack_public_path__ + "static/media/powerbi.c0b727dd.svg";